export enum KEYBOARD_EVENT_KEYS {
	SPACEBAR = ' ',
	ENTER = 'Enter',
	ESC = 27,
}

export const QUOTE_TYPE = {
	ROLLOVER: {
		value: 'ROLLOVER',
		label: 'Moving to another super fund',
	},
	RETIREMENT: {
		value: 'RETIREMENT',
		label: 'Retiring',
	},
};

export enum PAYMENTS_PRODUCT_NAME {
	PENSION = 'Pension',
	ACCUMULATION = 'Accumulation',
}

export enum PENDING_PROFILE {
	CHOICE_INCOME = 'Choice Income',
	ACCUMULATION = 'Accumulation',
}

export enum PENDING_STATUS {
	ACTIVE = 'active',
	PROVISIONAL = 'provisional',
}

export enum PRODUCT_NAME_ALIAS {
	ACCUMULATION = 'Super',
	PENSION = 'Choice Income',
	TTR = 'TTR Income',
}

export enum MEMBER_STATUS {
	ACTIVE = 'active',
	INACTIVE = 'inactive',
	PENDING = 'pending',
	CREATED = 'created',
}

export enum ACCOUNT_STATUS {
	ACTIVE = 'ACTIVE',
	INACTIVE = 'INACTIVE',
	PENDING = 'PENDING',
	PROVISIONAL = 'PROVISIONAL',
	HOLDING = 'HOLDING',
}

export enum REGISTRATION_STATUS {
	INCOMPLETE = 'INCOMPLETE',
	ACTIVE = 'ACTIVE',
	LOCKED = 'LOCKED',
}
export enum LOGOUT_STATUS {
	LOGOUT = 'logout',
	IDLE = 'idle',
	LOGOUT_JWT = 'logout-jwt',
}

export enum PHONE_NUMBERS_TYPE {
	WORK = 'WORK',
	HOME = 'HOME',
	FAX = 'FAX',
	MOBILE = 'MOBILE',
}

export enum MODAL_ARIA_NAMES {
	HEADING = 'modal-heading',
	DESCRIPTION = 'modal-description',
}

export const OVERLAY_IDS = {
	ACCOUNT_SWITCHER: 'account-switcher',
	IA_GUIDED_TOUR: 'ia-guided-tour',
	IA_GUIDED_TOUR_HIGHLIGHTS: 'ia-guided-tour-highlights',
	DB_OUTAGE: 'db-outage',
	ONBOARDING_ALL_SET: 'onboarding-all-set',
	ONBOARDING_HIGHLIGHTS: 'onboarding-highlights',
	MANAGE_BENEFICIARIES: 'manage-beneficiaries',
	PROFILE_SETUP_ACTIONS: 'profile-setup-actions',
} as const;

export const OVERLAY_PRIORITY = {
	ACCOUNT_SWITCHER: 0,
	IA_GUIDED_TOUR: 10,
	IA_GUIDED_TOUR_HIGHLIGHTS: 20,
	DB_OUTAGE: 25,
	ONBOARDING_ALL_SET: 30,
	ONBOARDING_HIGHLIGHTS: 40,
	MANAGE_BENEFICIARIES: 50,
	PROFILE_SETUP_ACTIONS: 60,
	DEFAULT: 999,
} as const;

export enum MODAL_CANCEL_ARIA_NAMES {
	HEADING = 'modal-cancel-heading',
	DESCRIPTION = 'modal-cancel-description',
}

export enum IDV_PROCESS_TYPE {
	FULL_IDV = 'FULL_IDV',
	STEP_UP = 'STEP_UP',
}

export enum IDV_FORM_TYPE {
	UPDATE_MOBILE_NUMBER = 'UPDATE_MOBILE_NUMBER',
	BANK_ACCOUNT = 'BANK_ACCOUNT',
	SECURITY_VERIFICATION = 'SECURITY_VERIFICATION',
	WITHDRAWAL_UNP = 'WITHDRAWAL_UNRESTRICTED_NON_PRESERVED',
}

export enum IDV_FORM_RESULT {
	VERIFIED = 'VERIFIED',
	FAILED = 'FAILED',
	LOCKED = 'LOCKED',
}

export enum IDV_FORM_FAILED_REASON {
	USER_DATA_MATCH = 'FAIL_USER_DATA_MATCH',
}

export const IDV_OVERRIDE_PARAM = 'IdvOverride';

export enum DAON_POST_MESSAGE_TYPE {
	WEB_COMPLETED = 'webCompleted',
	WEB_TIMEOUT = 'webTimeout',
	QR_CODE_SCANNED = 'qrCodeScanned',
	ERROR = 'error',
}

export enum DAON_POST_MESSAGE {
	CANT_VERIFY_IDENTITY = 'CantVerifyIdentity',
	MISMATCH_VERIFY_IDENTITY = 'DataMatchFailed',
	LOCKED = 'TempLocked',
}

export type TTR_CLASSIFICATION_TYPE = 'TTR' | undefined;

export const NON_NUMBER_CHAR_ARRAY = ['e', 'E', '+', '-'];

export const QUALIFIED_NAME = 'download';

export const SITECORE_PAGE_MODE = ['preview', 'edit'];

export const ZERO_WITH_DECIMALS = '0.00';

export const NAN = '$NaN';

export const MEMBER_DIRECT_SSO_URL_TEMPLATE =
	'<%- baseUrl %>?product_name=<%- productName %>&account_number=<%- accountNumber %>';

export const WITHDRAWAL_FULL_BALANCE = '$ 0';

export const NO_PREVIOUS_LOGIN = 'No previous login';

export const DEFAULT_TIMEZONE_LABEL = 'AEST/AEDT';

export const LOGIN_UUID_KEY = 'deviceID';

export const MOBILE_BP = '0,s';

export const VERIFICATION_INFO_KEY = 'verificationInformation';

export const IDV_UPDATE_MOBILE_URL_FROM_KEY = 'idvUpdateMobileUrlFrom';

export const VERIFICATION_SUCCESS_KEY = 'verificationSuccessKey';

export const IDV_VERIFICATION_DETAILS = 'idvVerificationDetails';

export const IMPORTANT_NOTICE_KEY_NAME = 'ImportantNoticeKeyName';

export const ANNUAL_STATEMENT_NOTIFICATION_KEY =
	'AnnualStatementNotificationToken';

export enum TAL_ACTION_ID_TYPE {
	MAKE_A_CLAIM = 'MAKE_A_CLAIM',
	MANAGE_INSURANCE = 'MANAGE_INSURANCE',
}

export enum INVESTMENT_OPTION_STATUS {
	ACTIVE = 'ACTIVE',
	INACTIVE = 'INACTIVE',
}

export const ARIA_LABELS = {
	LEARN_MORE_ABOUT_IDV_POP_UP:
		'Learn more about identity verification opens a pop up content',
	OPENS_CONTACT_US_PAGE: 'Opens contact us page',
	HOW_TO_CHANGE_LAST_NAME_POP_UP:
		'How can I change my last name opens a pop up content',
	FAQ_LINK: 'Frequently asked questions opens to a new tab',
};

export const ARIA_LABELLEDBY = {
	HOW_TO_CHANGE_LAST_NAME: 'How to update last name',
};
